import { render, staticRenderFns } from "./cabinetLessons.vue?vue&type=template&id=7f3e0011&scoped=true&lang=pug&"
import script from "./cabinetLessons.vue?vue&type=script&lang=js&"
export * from "./cabinetLessons.vue?vue&type=script&lang=js&"
import style0 from "./cabinetLessons.vue?vue&type=style&index=0&id=7f3e0011&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3e0011",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
